export default {
      id: "arrow-drop-usage",
      viewBox: "0 0 21 11",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#arrow-drop",
      toString: function () {
        return this.url;
      }
    }